import axios from '../utils/AxiosInterceptor';

export async function catalogGet(path, params = {}, signal) {
  return apiPageGet('/catalog' + path, params, signal);
}

export async function apiPageGet(path, params = {}, signal) {
  const response = await axios.get(path, { params, signal, timeout: 15000 });
  return response.data;
}

export const loadError = error => error.response?.data?.error || error.response?.data?.message || error.message || 'Unable to load data. Please retry.';
